module.exports = "<div class=q-expandable-body> <div class=q-marg-vert-md> <div class=\"q-alert q-alert-grey\"> No affiliated carriers have been set for this organization. </div> </div> <div class=drawer-area-for-affiliated-carrier></div> <div class=paging-area-for-affiliated-carrier></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/addressBook/html/orgDetails/noaffiliatedCarriers.html
// module id = 1195
// module chunks = 1